export const REDUCER_NAME = "ticketsSlice";

export type TicketCategory = 'BILLING' | 'TECHNICAL' | 'ACCOUNT' | 'OTHER';
export type TicketPriority = 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT';
export type TicketStatus = 'OPEN' | 'IN_PROGRESS' | 'RESOLVED' | 'CLOSED';

export interface ITicket {
  id: string;
  userId: string;
  subject: string;
  category: TicketCategory;
  priority: TicketPriority;
  status: TicketStatus;
  assignedAgentId: string | null;
  createdAt: string;
  updatedAt: string;
  firstName?: string;
  lastName?: string;
  email?: string;
}

export interface ITicketMessage {
  id: string;
  ticketId: string;
  authorId: string;
  authorRole: 'CUSTOMER' | 'AGENT';
  message: string;
  attachmentUrl?: string | null;
  createdAt: string;
  firstName?: string;
  lastName?: string;
}

export interface ITicketStats {
  byStatus: Record<string, number>;
  byPriority: Record<string, number>;
  byCategory: Record<string, number>;
  unassigned: number;
  createdThisWeek: number;
}

export interface ITicketsState {
  isLoading: boolean;
  myTickets: ITicket[];
  myTicketsTotal: number;
  allTickets: ITicket[];
  allTicketsTotal: number;
  stats: ITicketStats | null;
  activeTicket: ITicket | null;
  activeTicketMessages: ITicketMessage[];
  errorMessage: string | null;
  replyLoading: boolean;
}

export interface ICreateTicketDTO {
  subject: string;
  message: string;
  category?: TicketCategory;
  priority?: TicketPriority;
  attachment?: File | null;
}

export interface IReplyTicketDTO {
  id: string;
  message: string;
  attachment?: File | null;
}

export interface IGetAllTicketsDTO {
  status?: TicketStatus;
  priority?: TicketPriority;
  category?: TicketCategory;
  assignedAgentId?: string;
  page?: number;
  pageSize?: number;
}

export interface IUpdateTicketStatusDTO {
  id: string;
  status: TicketStatus;
}

export interface IUpdateTicketPriorityDTO {
  id: string;
  priority: TicketPriority;
}

export interface IAssignTicketDTO {
  id: string;
  assignedAgentId: string;
}
